// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1FMr1","icon":"SortAdornment_icon__2bT5S","up":"SortAdornment_up__373hO","down":"SortAdornment_down__PQQlA","active":"SortAdornment_active__3qUzS"};